// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonTip{
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
    border-radius: 24px;
    background: #F3EDF7;
    padding: 12px 16px;

    font-weight: 400;
    font-size: 12px;
    line-height: 20px;

    width: 268px;

    color: #49454F;
}

.commonTip_header{
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;

    color: #49454F;

    padding-bottom: 21px;
}

.commonTip_text{
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;

    color: #49454F;
}

.commonTip_buttons{
    padding-top: 4px;
    display: flex;
    gap: 8px;
}

.commonTip_button{
    display: flex;
    align-items: center;
    text-align: center;
    color: #65558F;
    padding: 10px 12px;
    margin-left: -12px;
}

.commonTip_button:hover{
    text-decoration: underline;
}

.commonTip_button_primary{
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
}

.commonTip_button_secondary{
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/commonTip/CommonTip.css"],"names":[],"mappings":"AAAA;IACI,+EAA+E;IAC/E,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;;IAElB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,YAAY;;IAEZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;;IAEd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".commonTip{\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15);\n    border-radius: 24px;\n    background: #F3EDF7;\n    padding: 12px 16px;\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n\n    width: 268px;\n\n    color: #49454F;\n}\n\n.commonTip_header{\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n\n    color: #49454F;\n\n    padding-bottom: 21px;\n}\n\n.commonTip_text{\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n\n    color: #49454F;\n}\n\n.commonTip_buttons{\n    padding-top: 4px;\n    display: flex;\n    gap: 8px;\n}\n\n.commonTip_button{\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: #65558F;\n    padding: 10px 12px;\n    margin-left: -12px;\n}\n\n.commonTip_button:hover{\n    text-decoration: underline;\n}\n\n.commonTip_button_primary{\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.commonTip_button_secondary{\n    font-style: italic;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
